export default class Event {
  constructor(type, data) {
    this.type = type;
    this.data = data;
  }
}
